export default {
  firstName: {
    it: 'Type hier je familienaam'
  },

  firstNameError: {
    it: 'Voer een geldige familie naam in'
  },

  familyName: {
    it: 'Familienaam'
  },

  familyNameError: {
    it: 'Voer een geldige voornaam in'
  },

  familyMembers: {
    it: 'Aantal familieleden'
  },

  familyMembersError: {
    it: 'Min len 1 max 8'
  },

  nameAvatar: {
    it: 'Naam familielid'
  },

  namePlaceholder: {
    it: 'Type hier de naam'
  },

  nameAvatarError: {
    it: 'Voer een geldige voornaam in'
  }
};
